import React from 'react';
import './ProtectedImage.css';

const ProtectedImage = ({ src, alt = '', style = {}, className = '' }) => {
  const handleContextMenu = (e) => e.preventDefault();
  const handleDragStart = (e) => e.preventDefault();

  return (
    <div
      className={`protected-image-wrapper ${className}`}
      style={style}
      onContextMenu={handleContextMenu}
      onDragStart={handleDragStart}
    >
      <div
        className="protected-image-bg"
        style={{ backgroundImage: `url(${src})` }}
        role="img"
        aria-label={alt}
      />
      <div className="protected-image-overlay" />
    </div>
  );
};

export default ProtectedImage;
